/**
 * Mood meter form input
 */

export default (() => {
  ;(() => {
    const blocks = document.querySelectorAll('[data-mood-rating]')

    const sync = (block) => {
      const checked = block.querySelector('.mood-input:checked')
      block.classList.toggle('has-selection', Boolean(checked))
      block.dataset.value = checked ? checked.value : ''

      block.dispatchEvent(
        new CustomEvent('mood-rating:change', {
          bubbles: true,
          detail: {
            value: checked ? checked.value : null,
            input: checked || null,
          },
        })
      )
    }

    blocks.forEach((block, index) => {
      const existingName = block
        .querySelector('.mood-input[name]')
        ?.getAttribute('name')
      const groupName = existingName || `mood-rating-${index + 1}`

      const items = block.querySelectorAll('.mood-item')
      items.forEach((item) => {
        const input = item.querySelector('.mood-input')
        const label = item.querySelector('.mood-label')
        if (!input || !label) return

        if (!input.name) input.name = groupName

        if (!input.id) {
          const safeValue = (input.value || 'option')
            .toString()
            .trim()
            .toLowerCase()
            .replace(/\s+/g, '-')
          input.id = `${groupName}-${safeValue}`
        }

        if (!label.getAttribute('for')) label.setAttribute('for', input.id)
      })

      sync(block)

      block.addEventListener('change', (event) => {
        if (!event.target.classList.contains('mood-input')) return
        sync(block)
      })
    })
  })()
})()
